module.exports = global["T"] = require("-!/app/node_modules/expose-loader/index.js?Translations!/app/node_modules/babel-loader/lib/index.js?{\"presets\":[\"es2015\"]}!/app/node_modules/eslint-loader/index.js!./translations.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?T!./~/expose-loader?Translations!./public/javascripts/translations.js-exposed
// module id = 83
// module chunks = 0